module.exports = __webpack_public_path__ + "static/media/arrow-left-solid.83cb0883.svg";